import { useEffect } from 'react';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';

export const NoPaymentsHookStripe = () => {
  const {
    anyLocationHasPayments,
    multiStep: { onCancel },
    stripeData: { stripeCreatedNotOnboarded },
    paymentSetupModalControl: { openModal },
    onLocationHasNoPayments,
    shouldShowCareCredit,
  } = useCollectPaymentMultiContext();

  const { navigate } = useSettingsNavigate();

  useEffect(() => {
    // need to add some sort of CC treatment here because
    // if we don't, the settings modal opens and prompts the
    // user to sign up for stripe
    if (!anyLocationHasPayments && !shouldShowCareCredit) {
      if (typeof onLocationHasNoPayments === 'function') {
        onLocationHasNoPayments();
      } else {
        if (!stripeCreatedNotOnboarded) {
          navigate({ to: '/payments/account-info' });
        } else {
          openModal();
        }
      }

      onCancel?.();
    }
  }, [anyLocationHasPayments, stripeCreatedNotOnboarded]);

  return <></>;
};
